// src/pages/RoleManagement/modals/RoleModulesListModal.tsx
// Popup hiển thị đầy đủ danh sách Module (kèm số quyền) mà 1 role đang được gán — dùng khi số lượng
// module quá nhiều để hiển thị hết trực tiếp trên RoleGroupCard (mục 9, REQUIRE_ROLEMODULE.md).
// Chỉ xem, không chỉnh sửa — việc gán/bỏ module vẫn thực hiện ở popup "Cập nhật permission".

import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, ListGroup, ListGroupItem } from 'reactstrap';
import { RoleGroup, Module } from '../types';
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('role_management');

interface RoleModulesListModalProps {
  isOpen: boolean;
  toggle: () => void;
  roleGroup: RoleGroup | null;
  assignedModules: Module[];
}

const RoleModulesListModal: React.FC<RoleModulesListModalProps> = ({
  isOpen,
  toggle,
  roleGroup,
  assignedModules,
}) => {
  if (!roleGroup) return null;

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="md">
      <ModalHeader toggle={toggle}>
        {st('module_duoc_gan_title')} {roleGroup.name}
      </ModalHeader>
      <ModalBody>
        {assignedModules.length > 0 ? (
          <ListGroup>
            {assignedModules.map((module) => (
              <ListGroupItem key={module.id} className="d-flex align-items-center justify-content-between">
                <span>
                  {module.icon && <i className={`${module.icon} me-2`}></i>}
                  {module.name}
                </span>
                <span className="text-muted small">{module.permissionCount} {st('quyen_hint')}</span>
              </ListGroupItem>
            ))}
          </ListGroup>
        ) : (
          <span className="text-muted">{st('khong_co_module_nao_duoc_gan_text')}</span>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="light" onClick={toggle}>
          {st('dong_button')}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default RoleModulesListModal;
